export interface HFRadioItem {
  label: string;
  value: string;
  disabled: boolean;
  labelPosition: string;
  translatableLabel?: boolean;
  text?: string;
  iconPaths?: string[];
}
